@use "variables" as *;

.container {
  width: 100%;
  display: flex;
}

.actionArea {
  display: flex;
  height: 100%;
  padding: $spacing-s $spacing-l !important;
}

.positionContainer {
  width: fit-content !important;
}

.lengthContainer {
  width: 80px !important;
}

.position {
  font-size: $fontSize-m;
  font-weight: bolder;
  min-width: 24px !important;
}

.name {
  font-size: $fontSize-m;
  font-weight: bold;
  text-align: left;
  width: 100%;
  word-wrap: anywhere;
}

.extraArtists {
  font-size: $fontSize-xxs;
  font-weight: normal;
  white-space: pre-wrap;
  width: 100%;
  text-align: left;
  vertical-align: top;
}

.length {
  font-size: $fontSize-m;
  font-weight: bolder;
  width: 40px;
}

.deleteButton {
  aspect-ratio: 1;
  border-radius: 0 !important;
  width: fit-content !important;
}

.dragIcon {
  align-self: center;
}
